import type { DeepPartial } from '@luna/utils-ts';

import type {
    SharedShorthandTransactionsFeatures,
    SharedTransactionsFeatures,
} from '../../types/SharedTransactionsFeatures';

export const features: DeepPartial<SharedTransactionsFeatures> = {};
export const shorthandFeatures: DeepPartial<SharedShorthandTransactionsFeatures> = {};
